import { useQuery } from "@tanstack/react-query";
import { apiStore } from "../stores/api.store";

export interface DevLogRow {
	subject: string;
	id: string;
	topic: string;
	created: string | Date;
	transactionId: string;
	req: any;
	res: any;
	status: number;
	userId: string;
	roles: string[];
}

export interface ResponseTimeStatsResponse {
	total: { count: number; avg: number };
	byMethod: {
		POST: { count: number; avg: number };
		GET: { count: number; avg: number };
		PUT: { count: number; avg: number };
		DELETE: { count: number; avg: number };
		PATCH: { count: number; avg: number };
	};
	topSlowResponses: {
		method: string;
		path: string;
		created: Date;
		ms: number;
	}[];
}

type GetDevLogParams = {
	topic?: string;
	id?: string;
};

export function useDevLogByTopic(params: GetDevLogParams, enabled?: boolean) {
	return useQuery(
		["dev-log", params.topic, params.id],
		() =>
			apiStore
				.get<DevLogRow[]>({
					path: `/dev/log/${params.topic}/${params.id}`,
					isAuthRequired: true,
				})
				.then((d) => d.data),

		{ enabled: !!params.topic && !!params.id && enabled }
	);
}

type GetDevLogByOrgParams = {
	status?: number[];
};

export function useDevLogByOrganisation(params: GetDevLogByOrgParams, enabled?: boolean) {
	return useQuery(["dev-log", "org", params], () =>
		apiStore
			.get<DevLogRow[]>({
				path: `/dev/log`,
				query: {
					statusFromTo: params.status?.join("-") || "",
				},
				isAuthRequired: true,
			})
			.then((d) => d.data)
	);
}

export function useDevResponseTimeStats() {
	return useQuery(["dev-log", "response-time-stats"], () =>
		apiStore
			.get<ResponseTimeStatsResponse>({
				path: `/dev/response-time-stats`,
				isAuthRequired: true,
			})
			.then((d) => d.data)
	);
}

interface LoggedNotification {
	transactionId: string;
	type: "notification" | "mail";
	to: string[];
	from?: string;
	notification?: {
		title?: string;
		body?: string;
	};
	mail?: {
		subject: string;
		body: string;
	};
	req: any;
	created: Date;
	status?: number;
}

type NotificationLogParams = {
	to?: string;
	id?: string;
};

export function useNotificationLog(params: NotificationLogParams, enabled?: boolean) {
	return useQuery(
		["notification-log", params],
		() =>
			apiStore
				.get<LoggedNotification[]>({
					path: `/dev/notification-log`,
					isAuthRequired: true,
				})
				.then((d) => d.data),

		{ enabled }
	);
}
